import { isWeb, isReactNative } from '../platform.js';
import { WebAuthStorage } from './WebStorage.js';
import { ReactNativeAuthStorage } from './ReactNativeStorage.js';

const createUniversalStorage = (options)=>{
    if (isWeb()) {
        return new WebAuthStorage(options);
    } else if (isReactNative()) {
        return new ReactNativeAuthStorage(options);
    } else {
        console.warn('Unknown platform, using InMemoryStorage as fallback');
        const store = new Map();
        return {
            setItem: async (k, v)=>void store.set(k, v),
            getItem: async (k)=>store.get(k) ?? null,
            removeItem: async (k)=>void store.delete(k),
            clear: async ()=>void store.clear(),
            // @ts-ignore - optional in KeyValueStorageInterface
            getAllValues: ()=>Array.from(store.entries()).map(([key, value])=>({
                        key,
                        value
                    }))
        };
    }
};

export { createUniversalStorage };
//# sourceMappingURL=index.js.map
